<template>
  <div class="header-main">
    <div class="main-logo">
      <router-link :to="{name: 'mainPage'}" v-if="!user">
        <img :src="logo" alt="Logo" />
      </router-link>
      <router-link :to="{name: 'welcomePage'}" v-else>
        <img :src="logo" alt="Logo" />
      </router-link>
    </div>

    <div class="menu-button-content" v-if="user">
      <div class="menu-button">
        <menu-icon title="open" @click.native="clickSmMenu" />
      </div>
    </div>
    <div class="main-right">
      <SingInPage class="main-panel-sign-in" v-if="!user" />

      <div v-if="user" class="inner-right">
        <span class="header-separator"></span>
        <SearchMultiInput
          :types="searchOptions"
          :selectedType="searchOptions[0]"
          :class="{'search-open':searchBlock}"
        />
        <SearchIcon v-if="!searchBlock" />

        <span v-if="offerEnable" class="header-separator"></span>
        <OfferIcon v-if="offerEnable && !searchBlock" />
        <span class="header-separator"></span>
        <BasketIcon v-if="!searchBlock" />

        <span class="header-separator"></span>
        <UserDropDownButton v-if="!searchBlock" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { SingInPage } from "../RedbayComponents";
import DropdownMenu from "redbay-b2b-layout/src/navigation/DropdownMenu.vue";
import CategoriesIcons from "redbay-b2b-categories/src/CategoriesIcon.vue";
import BrandsIcon from "./../brands/src/BrandsIcon.vue";
import SearchMultiInput from "redbay-b2b-layout/src/input/SearchMultiInput.vue";
import BasketIcon from "redbay-b2b-layout/src/button/BasketIcon.vue";
import UserDropDownButton from "redbay-b2b-layout/src/button/UserDropDownButton.vue";
import MenuIcon from "vue-material-design-icons/Menu.vue";
import OfferIcon from "redbay-b2b-offer/src/OfferIcon.vue";
import SearchIcon from "redbay-b2b-layout/src/button/SearchIcon.vue";

import { storeEmitter } from "../../state/store";

export default {
  components: {
    SingInPage,
    DropdownMenu,
    CategoriesIcons,
    BrandsIcon,
    SearchMultiInput,
    BasketIcon,
    UserDropDownButton,
    MenuIcon,
    OfferIcon,
    SearchIcon
  },
  computed: {
    ...mapState({
      user: state => state.user.authorizedUser,
      searchBlock: state => state.searchBlock
    })
  },
  props: ["scrolled"],
  data() {
    return {
      logo: "",
      searchOptions: ""
    };
  },
  methods: {
    clickSmMenu() {
      storeEmitter.emit("open-sm");
    }
  },
  beforeMount() {
    this.logo = this.$config.get("header.main.logo");
    this.searchOptions = this.$config.get("header.main.searchOptions");
    this.offerEnable = this.$config.get("offer.enable");
  }
};
</script>



// WEBPACK FOOTER //
// src/components/template/HeaderMain.vue